import { types as t, types } from '@invisr/mobx-state-tree'
import crudActions from './crud-actions'

export default types
  .model('credentialsProp', {
    credentials: t.maybeNull(t.string)
  })
  .actions(crudActions)
